const autocompleteTimeInputIfCan = (input) =>
  input.length >= 3 ? input.padEnd(5, '0') : input;
export default autocompleteTimeInputIfCan;
